import { Component } from '@angular/core';


export class SkyRepeaterDemoComponent {
  public items: any[];
  public expandMode = 'single';
  public selectable = false;

  constructor() {
    this.items = [
      {
        title: 'Call Robert Hernandez',
        note: 'Robert recently gave a very generous gift.  We should call him to thank him.',
        status: 'Completed',
        statusType: 'success'
      },
      {
        title: 'Send invitation to Spring Ball',
        note: 'The Spring Ball is coming up soon.  Let\'s get those invitations out!',
        status: 'Past due',
        statusType: 'warning'
      }
    ];
  }

  public addItem() {
    let next = this.items.length + 1;
    this.items.push({
      title: 'New reminder ' + next,
      note: 'This is a new reminder',
      expanded: true,
      status: 'Active',
      statusType: 'info'
    });
  }

  public removeItem() {
    this.items.pop();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-repeater-demo',
  template: `<sky-repeater
  [expandMode]="expandMode">

  <sky-repeater-item
    *ngFor="let item of items"
    [isExpanded]="item.expanded"
    [selectable]="selectable">

    <sky-repeater-item-title
      ng-if="repeaterCtrl.showTitle">
      <div class="pull-left">
        {{item.title}}
      </div>
      <div class="pull-right">
        <span
          class="label"
          ng-class="repeaterCtrl.getStatusCls(item)">
          {{item.status}}
        </span>
      </div>
    </sky-repeater-item-title>
    <sky-repeater-item-content>
      <div>
        {{item.note}}
      </div>
    </sky-repeater-item-content>
  </sky-repeater-item>
</sky-repeater>

<p>
  <label>
    Expand mode:
    <select [(ngModel)]="expandMode">
      <option value="none">
        None
      </option>
      <option value="single">
        Single
      </option>
      <option value="multiple">
        Multiple
      </option>
    </select>
  </label>
  <button class="sky-btn" (click)="addItem()">Add item</button>
  <button class="sky-btn" (click)="removeItem()">Remove last item</button>
  <sky-checkbox [(ngModel)]="selectable">
    <sky-checkbox-label>
      Show checkbox
    </sky-checkbox-label>
  </sky-checkbox>
</p>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
